/** Single source for media-type badge label + Bootstrap class. */
const MEDIA_TYPE_BADGES = {
	dsp: { label: "DSP", class: "badge-success" },
	rewarded: { label: "Rewarded", class: "badge-info" },
	leadgen: { label: "Leadgen", class: "badge-primary" },
	media_buying: { label: "Media Buying", class: "badge-warning" },
};

function fallbackLabel(mediaType) {
	if (!mediaType) {
		return "Unknown";
	}
	return mediaType
		.replace(/[_-]+/g, " ")
		.replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function getMediaTypeBadge(mediaType) {
	const key = (mediaType || "").toLowerCase();
	return MEDIA_TYPE_BADGES[key] || {
		label: fallbackLabel(mediaType),
		class: "badge-secondary",
	};
}

export function formatMediaType(mediaType) {
	return getMediaTypeBadge(mediaType).label;
}

export function mediaTypeBadgeClass(mediaType) {
	return getMediaTypeBadge(mediaType).class;
}
